import { NgModule } from '@angular/core';
import { PreloadingStrategy, Route, RouterModule, Routes } from '@angular/router';
import { AuthGuard, MihmoAuthModule } from '@recriar/mihmo-auth';
import { AppGuard } from './app.guard';
import { Observable, of } from 'rxjs';

class ConsultaPreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    return window.location.pathname.startsWith('/consulta') && route.path === 'consulta'
      ? load()
      : of(null);
  }
}

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    // Referência estática de propósito. O `import()` dinâmico dava a entender
    // que a mihmo-auth era lazy, mas o chunk gerado tinha 603 bytes: o código
    // real (32 KB) já vinha no main, porque 235 arquivos do admin importam a
    // lib estaticamente (AuthGuard, UserService, UserModel...).
    // O router continua instanciando o módulo só ao navegar para /auth.
    // Ver .claude/DEV-EXPERIENCE.md seção 2.
    loadChildren: () => MihmoAuthModule,
  },
  {
    // Vitrine do agendamento, sem AuthGuard, para demonstração a interessados.
    // Precisa vir antes da rota '' para não cair no AuthGuard. Andaime: remover
    // junto com SchedulingDemoComponent quando o modal tiver entrada real.
    path: 'agendamento-demo',
    loadChildren: () =>
      import('./features/scheduling/scheduling-demo.routes').then(
        (m) => m.SCHEDULING_DEMO_ROUTES,
      ),
  },
  {
    // Agendamento pelo próprio miHmado, via link enviado no WhatsApp. Sem
    // AuthGuard, e antes da rota '' pelo mesmo motivo da demo acima.
    path: 'agendamento',
    loadChildren: () =>
      import('./features/external-scheduling/external-scheduling.routes').then(
        (m) => m.EXTERNAL_SCHEDULING_ROUTES,
      ),
  },
  {
    path: '',
    canActivate: [AuthGuard, AppGuard],
    loadChildren: () =>
      import('./features/features.module').then((m) => m.FeaturesModule),
  },
  {
    path: 'modal',
    outlet: 'modal',
    canActivate: [AppGuard],
    loadChildren: () =>
      import(
        './features/main-information-modal/main-information-modal.module'
      ).then((m) => m.MainInformationModalModule),
  },
  {
    // Guest/patient video room — no AuthGuard, accessed via shared link
    path: 'consulta',
    loadChildren: () =>
      import('./features/zoom/guest-room/zoom-guest-room.module').then(
        (m) => m.ZoomGuestRoomModule,
      ),
  },
  { path: '**', redirectTo: 'home', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: ConsultaPreloadingStrategy,
    }),
  ],
  providers: [ConsultaPreloadingStrategy],
  exports: [RouterModule],
})
export class AppRoutingModule {}
